import { render } from "./PrivacyPolicy.vue?vue&type=template&id=b20edd90&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=b20edd90&scoped=true&lang=css"

import exportComponent from "/Users/jaakkojakara/Documents/Aekosbot/apps/aekosweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20edd90"]])

export default __exports__